import React, { useState, useEffect } from "react";
import "./AvatarSelect.scss";
import AvatarGroup from "../../../ui/avatarGroup/AvatarGroup";
import Avatar from "../../../ui/avatar/Avtar";
import Iconify from "../../../../layouts/components/iconify/iconify";
import { DropdownWrapper } from "../../../ui/dropdownwrapper/DropdownWrapper";

const AvatarSelect = ({
  options,
  selectMode,
  initState,
  onSelectionChange,
  id,
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    setSelectedOptions(
      selectMode === "single" ? [initState] : initState ? [initState] : []
    );
  }, [initState, selectMode]);

  const handleToggleOption = (option) => {
    if (selectMode === "single") {
      setSelectedOptions([option]);
      onSelectionChange([option], id);
    } else {
      const currentIndex = selectedOptions.findIndex(
        (o) => o.value === option.value
      );
      const newSelectedOptions = [...selectedOptions];

      if (currentIndex === -1) {
        newSelectedOptions.push(option);
      } else {
        newSelectedOptions.splice(currentIndex, 1);
      }

      setSelectedOptions(newSelectedOptions);
      onSelectionChange(newSelectedOptions, id);
    }
  };

  // const handleDeleteAll = () => {
  //   setSelectedOptions([]);
  //   onSelectionChange([], id);
  // };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedOptions(options);
      onSelectionChange(options, id);
    } else {
      setSelectedOptions([]);
      onSelectionChange([], id);
    }
  };

  const renderAvatars = () => {
    return (
      <div
        onClick={selectMode === "single" ? null : undefined}
        style={{ cursor: selectMode === "single" ? "pointer" : "default" }}
      >
        {selectMode === "single" ? (
          <Avatar alt={selectedOptions[0]?.label} position="top" />
        ) : (
          <AvatarGroup
            avatars={selectedOptions}
            max={5}
            size="medium"
            shape="circle"
          />
        )}
      </div>
    );
  };

  const filteredOptions = options?.filter((option) =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      <DropdownWrapper
        closeOnSelect={selectMode === "single" ? true : false}
        toggleElement={
          <div className="avatarGroup">
            {renderAvatars()}
            <div className="actions">
              {selectMode === "multiple" && selectedOptions.length === 0 && (
                <div className="avatarButton">
                  <Iconify icon="mingcute:user-add-2-fill" />
                </div>
              )}
            </div>
          </div>
        }
        position="right"
      >
        <div
          className={`ele-dropdownMenu ${selectMode === "multiple" ? "multiple" : ""
            }`}
        >
          <div className="avatar-select-searchbar">
            <input
              type="text"
              placeholder="Search..."
              className="textField"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onClick={(e) => e.stopPropagation()}
            />
          </div>

          {/* Select All Checkbox */}
          {selectMode === "multiple" && options?.length > 0 && (
            <label className="menuItem selectall" onClick={handleSelectAll}>
              <input
                type="checkbox"
                checked={selectedOptions.length === options.length}
                readOnly
                className="checkbox"
              />
              <div>Select All</div>
            </label>
          )}

          {filteredOptions?.length > 0 ? (
            filteredOptions.map((option, index) => (
              <div
                key={index}
                className="menuItem"
                onClick={() => handleToggleOption(option)}
              >
                {selectMode === "multiple" && (
                  <input
                    type="checkbox"
                    checked={selectedOptions.some(
                      (o) => o.value === option.value
                    )}
                    onChange={() => handleToggleOption(option)}
                    className="checkbox"
                  />
                )}
                <div>{option.label}</div>
              </div>
            ))
          ) : (
            <div className="menuItem">
              <span>No results found</span>
            </div>
          )}
        </div>
      </DropdownWrapper>
    </div>
  );
};

export default AvatarSelect;
